<template>
  <div class="Productcenter">
    <div class="pagestitle clearfix">
      <span class="pageslink">
          <li><router-link class="indexicon" to="/" /></li>
          <li><router-link to="/jicheng">产品展示</router-link> > </li><li><router-link class='cur' :to="cur">{{curName}}</router-link></li>
      </span>
      <h4>
        <span>{{curName}}</span>
        <!--<img class="titleimg" :src="baseApi+'webimages/news.png'"  >-->
      </h4>
    </div>
    <div class="insidesnav clearfix">
      <router-link :class="cur === '/gaoyabianping' ? 'cur': ''" to="/gaoyabianping">高压变频器系列</router-link>
      <router-link :class="cur === '/diyabianping' ? 'cur': ''" to="/diyabianping">低压变频器系列</router-link>
      <router-link :class="cur === '/ruanqidong' ? 'cur': ''" to="/ruanqidong">软启动器</router-link>
      <router-link :class="cur === '/plc' ? 'cur': ''" to="/plc">PLC伺服控制系统</router-link>
      <router-link :class="cur === '/gaodiyadianji' ? 'cur': ''" to="/gaodiyadianji">高低压电机</router-link>
      <router-link :class="cur === '/gaodiyayuanjian' ? 'cur': ''" to="/gaodiyayuanjian">高低压电器元件</router-link>
      <router-link :class="cur === '/kaiguangui' ? 'cur': ''" to="/kaiguangui">开关柜</router-link>
      <router-link :class="cur === '/jiqijicheng' ? 'cur': ''" to="/jiqijicheng">工业机器人集成</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cur: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  computed: {
    curName () {
      switch (this.cur) {
        case '/gaoyabianping':
          return '高压变频器系列'
        case '/diyabianping':
          return '低压变频器系列'
        case '/ruanqidong':
          return '软启动器'
        case '/plc':
          return 'PLC伺服控制系统'
        case '/gaodiyadianji':
          return '高低压电机'
        case '/gaodiyayuanjian':
          return '高低压电器元件'
        case '/kaiguangui':
          return '开关柜'
        case '/jiqijicheng':
          return '工业机器人集成'
        default:
          return ''
      }
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/view/componets/Tab.vue